<div class="explorador-panel">

  <!-- HEADER -->

  <div class="panel-header">
    <div class="panel-title">
      <mat-icon>folder</mat-icon>
      <span>EXPLORADOR</span>
    </div>

    <div class="panel-actions">
      <button
        mat-icon-button
        class="action-btn"
        (click)="onNewEscrito()"
        matTooltip="Nuevo Escrito">
        <mat-icon>add</mat-icon>
      </button>

      <button
        mat-icon-button
        class="action-btn"
        (click)="onRefresh()"
        matTooltip="Actualizar">
        <mat-icon>refresh</mat-icon>
      </button>



      <button
        mat-icon-button
        class="action-btn"
        (click)="onFilterClick()"
        matTooltip="Filtros">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </div>

  <!-- SEARCH -->
  <div class="search-container">
    <div class="search-row">
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          placeholder="Buscar..."
          [formControl]="searchControl"
          maxlength="100"
          autocomplete="off">

        <button
          mat-icon-button
          matSuffix
          *ngIf="searchControl.value && !hasSearchErrors"
          (click)="searchControl.setValue('')">
          matTooltip="Limpiar">
          <mat-icon>clear</mat-icon>
        </button>

        <mat-icon
          matSuffix
          *ngIf="hasSearchErrors"
          color="warn"
          matTooltip="{{searchErrorMessage}}">
          error
        </mat-icon>

        <mat-error *ngIf="hasSearchErrors">
          {{ searchErrorMessage }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- LOADING -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Cargando...</span>
  </div>

  <!-- TREE -->
  <div class="tree-container" *ngIf="!isLoading">
    <mat-tree
      [dataSource]="dataSource"
      [treeControl]="treeControl"
      class="file-tree">

      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        class="tree-node"
        [class.selected]="false"
        (click)="onNodeClick(node)"
        (contextmenu)="onNodeRightClick($event, node)">

        <div class="node-content">
          <mat-icon class="node-icon" [class]="'icon-' + node.type">
            {{ node.icon || 'description' }}
          </mat-icon>
          <span class="node-label" [title]="node.name">{{ node.name }}</span>
        </div>
      </mat-tree-node>

      <mat-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodeToggle
        class="tree-node folder-node"
        [class.expanded]="treeControl.isExpanded(node)"
        (click)="onNodeClick(node)"
        (contextmenu)="onNodeRightClick($event, node)">

        <div class="node-content">
          <mat-icon class="toggle-icon">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
          <mat-icon class="node-icon folder-icon">
            {{ node.icon || 'folder' }}
          </mat-icon>
          <span class="node-label" [title]="node.name">{{ node.name }}</span>
        </div>
      </mat-tree-node>
    </mat-tree>

    <!-- EMPTY STATE -->
    <div *ngIf="dataSource.data.length === 0" class="empty-state">
      <mat-icon class="empty-icon">folder_open</mat-icon>
      <p>No se encontraron escritos</p>
      <button mat-stroked-button (click)="onNewEscrito()">
        <mat-icon>add</mat-icon>
        Crear Nuevo Escrito
      </button>
    </div>
  </div>

  <!-- CONTEXT MENU -->
  <div
    class="context-menu"
    *ngIf="showContextMenu"
    [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y"
    (clickOutside)="closeContextMenu()">

    <div
      *ngFor="let item of getContextMenuItems(contextMenuNode!)"
      class="context-menu-item"
      [class.divider]="item.divider"
      (click)="onContextMenuAction(item.action)">

      <mat-icon *ngIf="!item.divider">{{ item.icon }}</mat-icon>
      <span *ngIf="!item.divider">{{ item.label }}</span>
    </div>
  </div>

  <!-- OVERLAY -->
  <div
    class="context-menu-overlay"
    *ngIf="showContextMenu"
    (click)="closeContextMenu()">
  </div>
</div>
